module.exports = __webpack_public_path__ + "images/home/masters/qrcode-3914f82c0293569f57d2306f29773cef.png";